import React from 'react';
import styled, { keyframes } from 'styled-components';

/**
 * Skeleton placeholder for a single agenda row — shown while a day's calendar is loading. The
 * shape mirrors the real AgendaRow (time · thumb · title/meta · cta) so the resolved row swaps in
 * without a layout shift.
 */
const SkeletonAgendaRow = () => (
  <SkeletonRow className="schedule-view__skeleton-row" aria-hidden="true">
    <SkeletonTime />
    <SkeletonThumb />
    <SkeletonBody>
      <SkeletonTitle />
      <SkeletonMeta />
    </SkeletonBody>
    <SkeletonCta />
  </SkeletonRow>
);

export default SkeletonAgendaRow;

/* ---- skeleton loading (token-based, mirrors the agenda row layout) ---- */
const skeletonPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 0;
  width: 100%;
  border-bottom: 0.5px solid var(--way-colors-borderColor);

  @media all and (min-width: 768px) {
    gap: 32px;
  }
`;

const SkeletonBlock = styled.div`
  background: var(--way-colors-contrastColorShades-5);
  border-radius: 4px;
  flex: 0 0 auto;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${skeletonPulse} 1.4s ease-in-out infinite;
  }
`;

const SkeletonTime = styled(SkeletonBlock)`
  width: 56px;
  height: 14px;

  @media all and (min-width: 768px) {
    width: 76px;
  }
`;

const SkeletonThumb = styled(SkeletonBlock)`
  width: 72px;
  height: 54px;
`;

const SkeletonBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

const SkeletonTitle = styled(SkeletonBlock)`
  width: 42%;
  height: 14px;
`;

const SkeletonMeta = styled(SkeletonBlock)`
  width: 26%;
  height: 12px;
`;

const SkeletonCta = styled(SkeletonBlock)`
  width: 92px;
  height: 14px;
`;
